export const errorMessages = {
  BLANK: 'Please enter a URL.',
  DUPLICATE: 'Looks like we already have that URL!',
  NOPROTOCOL:
    'Looks like you forgot the https:// or http:// at the beginning! We need the whole URL to make sure your test is accurate.',
  NOHTTPS: `Please include "https://" in URL.`,
};
